package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_01_10_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes, who just obtained a Shard of Concar without a fight from Lord Fox in Freeburg.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes leave through the east gate and Wind Walk to the Wharf Side Wicket Inn where they meet Prudence of the Barrowmen. Earlier in the day, the heroes had turned over Ludwig Voss to the “care” of the Barrowmen. Voss had killed a Barrowman. Falorn inquires about Voss’s fate, concerned that the Barrowmen may have cut a deal with him. Prudence’s response seems somewhat evasive, but she claims that “he won’t be a problem in Freeburg” and “justice was done.”")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette offers to pay Prudence to investigate Ludwig Voss’s benefactor, Lord Verdus Pent. The Barrowmen themselves are curious about Lord Pent, and Prudence offers to conduct an initial investigate at no cost and will present a cost estimate on further investigation afterwards.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes return to the Leaping Ram Inn, where they discuss their next steps. Previously Elrovir Rodiridan (Lady Aventary’s husband) sailed from Freeburg to Kostigan in Ostvel to prepare for the Shard of Concar search in that region. The heroes agree that the Ostvel shard should be the next goal.")
    }
}
